import { createRoot } from "react-dom/client";
import "./index.css";
import RQuery from "./components/RQuery.tsx";
import { Toaster } from "sonner";
import { BrowserRouter } from "react-router";
import AppRoutes from "./routes.tsx";
import Header from "./components/common/layout/Header.tsx";
import Footer from "./components/common/layout/Footer.tsx";
import ScrollToTop from "./hooks/ScrollToTop.tsx";
import "./i18n"; // import i18n config
import { HelmetProvider } from "react-helmet-async";
import { SpeedInsights } from "@vercel/speed-insights/react"
import { Analytics } from "@vercel/analytics/react"

createRoot(document.getElementById("root")!).render(
  <div className="font-roboto antialiased">
    <BrowserRouter>
      <HelmetProvider>
        <ScrollToTop />
        <RQuery>
          <Toaster />
          <Header />
          <AppRoutes />
          <Footer />
          <SpeedInsights />
          <Analytics />
        </RQuery>
      </HelmetProvider>
    </BrowserRouter>
  </div>
);
